import { UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import styles from './CardDescription.css';

type CardDescriptionProps = {
  rowsAmount?: 2 | 4;
  description: string;
};

export const CardDescription: FC<CardDescriptionProps> = props => {
  const { description, rowsAmount } = props;

  return (
    <div className={clsx(styles['container'], !!rowsAmount && styles[`rows-${rowsAmount}`])}>
      <UIText2 as="p">{description}</UIText2>
    </div>
  );
};
